import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78fa50ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "Schedule",
  class: "schedule"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "Friday-desktop" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "Friday-mobile" }, null, -1))
const _hoisted_4 = { class: "schedule__section-buttons" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "schedule__dates-buttons" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"schedule__venues\" data-v-78fa50ce><div class=\"schedule__venue\" data-v-78fa50ce><div data-v-78fa50ce>La Fabrika <span class=\"schedule__venue-subtitle\" data-v-78fa50ce>(Livestream)</span></div><div class=\"schedule__venue-additional-info\" data-v-78fa50ce>Entrance #2</div></div><div class=\"schedule__venue\" data-v-78fa50ce><div data-v-78fa50ce>Paralelni Polis</div><div class=\"schedule__venue-additional-info\" data-v-78fa50ce>Registrations + Entrance #1</div></div><span class=\"schedule__venues-all-times-zone\" data-v-78fa50ce>All times are in CET</span></div>", 1)
const _hoisted_11 = {
  key: 0,
  class: "schedule__loading"
}
const _hoisted_12 = {
  key: 2,
  class: "schedule__content"
}
const _hoisted_13 = { class: "schedule__content--mobile" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"schedule__day-title\" data-v-78fa50ce>Friday 10. June</div><div class=\"schedule__venues-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening-text\" data-v-78fa50ce><strong data-v-78fa50ce>La Fabrika</strong> (Livestream)<br data-v-78fa50ce> Entrance #2<br data-v-78fa50ce> open door – 10am<br data-v-78fa50ce> close door – 10pm<br data-v-78fa50ce></div></div><div class=\"schedule__venue-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening-text\" data-v-78fa50ce><strong data-v-78fa50ce>Paralelni Polis</strong><br data-v-78fa50ce> Registrations + Entrance #1<br data-v-78fa50ce> open door – 10am<br data-v-78fa50ce> close door on Sunday<br data-v-78fa50ce></div></div></div>", 2)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div id=\"Saturday-mobile\" class=\"schedule__day-title\" data-v-78fa50ce> Saturday 11. June </div><div class=\"schedule__venues-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening-text\" data-v-78fa50ce><strong data-v-78fa50ce>La Fabrika</strong><br data-v-78fa50ce> Entrance #2<br data-v-78fa50ce> open door – 9am<br data-v-78fa50ce> close door – 10pm<br data-v-78fa50ce></div></div><div class=\"schedule__venue-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening-text\" data-v-78fa50ce><strong data-v-78fa50ce>Paralelni Polis</strong><br data-v-78fa50ce> Registrations + Entrance #1<br data-v-78fa50ce> nonstop </div></div></div>", 2)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div id=\"Sunday-mobile\" class=\"schedule__day-title\" data-v-78fa50ce> Sunday 12. June </div><div class=\"schedule__venues-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening-text\" data-v-78fa50ce><strong data-v-78fa50ce>La Fabrika</strong><br data-v-78fa50ce> Entrance #2<br data-v-78fa50ce> open door – 9am<br data-v-78fa50ce> close door – 7pm<br data-v-78fa50ce></div></div><div class=\"schedule__venue-opening\" data-v-78fa50ce><div class=\"schedule__venue-opening-text\" data-v-78fa50ce><strong data-v-78fa50ce>Paralelni Polis</strong><br data-v-78fa50ce> Registrations + Entrance #1<br data-v-78fa50ce> close door – 7pm </div></div></div>", 2)
const _hoisted_20 = { class: "schedule__content--desktop" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule__venues-opening" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening-text" }, [
      /*#__PURE__*/_createTextVNode(" open door – 10am"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" close door – 10pm"),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening-text" }, [
      /*#__PURE__*/_createTextVNode(" open door – 10am"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" close door on Sunday"),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule__venues-opening" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening" }, [
    /*#__PURE__*/_createTextVNode(" open door – 9am"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" close door – 10pm"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening" }, [
    /*#__PURE__*/_createTextVNode("nonstop"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule__venues-opening" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening" }, [
    /*#__PURE__*/_createTextVNode(" open door – 9am"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" close door – 7pm"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "schedule__venue-opening" }, [
    /*#__PURE__*/_createTextVNode("close door – 7pm"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))

import { ref, onMounted, onUpdated, onUnmounted, computed } from "vue";
import ModalSchedule from "./ModalSchedule.vue";
import ScheduleEventBox from "./ScheduleEventBox.vue";
import Speakers from "./Speakers.vue";
import { peopleData, fetchPeopleData } from "@/components/usePeople";
import { Venues } from "@/components/schedule/useSchedule";
import DayBlock from "./DayBlock.vue";
enum Sections {
  SCHEDULE = "schedule",
  SESSIONS = "sessions",
  SPEAKERS = "speakers",
}

enum Dates {
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}
const MOBILE_BREAKPOINT = 1120;


export default /*#__PURE__*/_defineComponent({
  __name: 'Schedule',
  setup(__props) {

const axios = require("axios").default;

const showSection = ref(Sections.SCHEDULE);
const showDate = ref(Dates.FRIDAY);
const scheduleJsonData = ref();
const loadingData = ref(true);

const friday = ref();
const saturday = ref();
const sunday = ref();
const fridayDesktopTitleElement = ref();
const saturdayDesktopTitleElement = ref();
const sundayDesktopTitleElement = ref();

const fridayMobileTitleElement = ref();
const saturdayMobileTitleElement = ref();
const sundayMobileTitleElement = ref();

const isOnDateClick = ref();
const modalContent = ref<any | null>(null);
const speakers = ref();
const allEvents = ref();

const headerSectionsButtonClasses = (section: string) =>
  `schedule__header-sections-button ${
    showSection.value === section
      ? "schedule__header-sections-button-active"
      : ""
  }`;

const onDateClick = (date: Dates) => {
  showDate.value = date;
  isOnDateClick.value = true;
  setTimeout(() => {
    isOnDateClick.value = false;
  }, 1000);
};

const headerDatesButtonClasses = (date: string) =>
  `schedule__header-dates-button ${
    showDate.value === date ? "schedule__header-dates-button-active" : ""
  }`;

const mergeEvents = (scheduleJsonData: any) => {
  const venues = [
    ...scheduleJsonData[Venues.PARALELNI_POLIS],
    ...scheduleJsonData[Venues.LA_FABRIKA],
  ];
  return venues.sort((a: any, b: any) => {
    return (
      Date.parse("01/01/2022 " + a.start) - Date.parse("01/01/2022 " + b.start)
    );
  });
};

const setModalContent = (event: any) => {
  modalContent.value = event;
};

const getLocalLinkForDates = (day: string) =>
  `${day}-${window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop"}`;

const updateScroll = () => {
  if (showSection.value !== Sections.SCHEDULE) return;

  let fridayYPosition;
  let saturdayYPosition;
  let sundayYPosition;

  if (window.innerWidth < MOBILE_BREAKPOINT) {
    fridayYPosition = fridayMobileTitleElement.value.getBoundingClientRect().y;
    saturdayYPosition =
      saturdayMobileTitleElement.value.getBoundingClientRect().y;
    sundayYPosition = sundayMobileTitleElement.value.getBoundingClientRect().y;
  } else {
    fridayYPosition = fridayDesktopTitleElement.value.getBoundingClientRect().y;
    saturdayYPosition =
      saturdayDesktopTitleElement.value.getBoundingClientRect().y;
    sundayYPosition = sundayDesktopTitleElement.value.getBoundingClientRect().y;
  }

  if (isOnDateClick.value) return;

  if (
    fridayYPosition - 185 < 0 &&
    saturdayYPosition - 185 > 0 &&
    sundayYPosition > 0
  ) {
    showDate.value = Dates.FRIDAY;
  } else if (saturdayYPosition - 185 < 0 && sundayYPosition - 185 > 0) {
    showDate.value = Dates.SATURDAY;
  } else if (sundayYPosition - 185 < 0) {
    showDate.value = Dates.SUNDAY;
  }
};

const getSpeakersFromEvents = (allEvents: any) => {
  const speakers = [];
  for (const event of allEvents) {
    for (const person of event.persons) {
      if (person.biography) {
        speakers.push(person);
      }
    }
  }
  return speakers;
};

onMounted(async () => {
  if (!peopleData.value) fetchPeopleData();

  try {
    loadingData.value = true;
    const jsonDataFetch = await axios.get(
      "https://cfp.paralelnipolis.cz/ethprague-2022/schedule/export/schedule.json"
    );
    scheduleJsonData.value = jsonDataFetch.data.schedule.conference.days;
    loadingData.value = false;
  } catch (e) {
    loadingData.value = false;
  }
  friday.value = mergeEvents(scheduleJsonData.value[0].rooms);
  saturday.value = mergeEvents(scheduleJsonData.value[1].rooms);
  sunday.value = mergeEvents(scheduleJsonData.value[2].rooms);

  allEvents.value = [...friday.value, ...saturday.value, ...sunday.value];
  speakers.value = getSpeakersFromEvents(allEvents.value);

  window.addEventListener("scroll", updateScroll, { passive: true });
});

onUpdated(() => {
  fridayMobileTitleElement.value =
    window.document.getElementById("Friday-mobile");
  saturdayMobileTitleElement.value =
    window.document.getElementById("Saturday-mobile");
  sundayMobileTitleElement.value =
    window.document.getElementById("Sunday-mobile");

  fridayDesktopTitleElement.value =
    window.document.getElementById("Friday-desktop");
  saturdayDesktopTitleElement.value =
    window.document.getElementById("Saturday-desktop");
  sundayDesktopTitleElement.value =
    window.document.getElementById("Sunday-desktop");
});

onUnmounted(() => {
  window.removeEventListener("scroll", updateScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass([
        'schedule__header',
        { 'schedule__header-speakers': showSection.value === Sections.SPEAKERS },
      ])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showSection.value = Sections.SCHEDULE)),
            class: _normalizeClass(headerSectionsButtonClasses(Sections.SCHEDULE))
          }, " schedule ", 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showSection.value = Sections.SPEAKERS)),
            class: _normalizeClass(headerSectionsButtonClasses(Sections.SPEAKERS))
          }, " speakers ", 2)
        ]),
        (showSection.value === Sections.SCHEDULE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  href: getLocalLinkForDates('#Friday')
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onDateClick(Dates.FRIDAY))),
                    class: _normalizeClass(headerDatesButtonClasses(Dates.FRIDAY))
                  }, " FRIDAY 10. JUNE ", 2)
                ], 8, _hoisted_7),
                _createElementVNode("a", {
                  href: getLocalLinkForDates('#Saturday')
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (onDateClick(Dates.SATURDAY))),
                    class: _normalizeClass(headerDatesButtonClasses(Dates.SATURDAY))
                  }, " SATURDAY 11. JUNE ", 2)
                ], 8, _hoisted_8),
                _createElementVNode("a", {
                  href: getLocalLinkForDates('#Sunday')
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onDateClick(Dates.SUNDAY))),
                    class: _normalizeClass(headerDatesButtonClasses(Dates.SUNDAY))
                  }, " SUNDAY 12. JUNE ", 2)
                ], 8, _hoisted_9)
              ]),
              _hoisted_10
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (loadingData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "loading..."))
        : _createCommentVNode("", true),
      (showSection.value === Sections.SPEAKERS)
        ? (_openBlock(), _createBlock(Speakers, {
            key: 1,
            speakers: speakers.value,
            allEvents: allEvents.value
          }, null, 8, ["speakers", "allEvents"]))
        : _createCommentVNode("", true),
      (scheduleJsonData.value && showSection.value === Sections.SCHEDULE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friday.value, (event) => {
                return (_openBlock(), _createBlock(ScheduleEventBox, {
                  key: event.id,
                  onClick: ($event: any) => (setModalContent(event)),
                  event: event
                }, null, 8, ["onClick", "event"]))
              }), 128)),
              _hoisted_16,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saturday.value, (event) => {
                return (_openBlock(), _createBlock(ScheduleEventBox, {
                  key: event.id,
                  onClick: ($event: any) => (setModalContent(event)),
                  event: event
                }, null, 8, ["onClick", "event"]))
              }), 128)),
              _hoisted_18,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sunday.value, (event) => {
                return (_openBlock(), _createBlock(ScheduleEventBox, {
                  key: event.id,
                  onClick: ($event: any) => (setModalContent(event)),
                  event: event
                }, null, 8, ["onClick", "event"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(DayBlock, {
                dayData: friday.value,
                onSetModalContent: setModalContent,
                title: "Friday 10. June",
                dayName: "Friday-disabled-local-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["dayData"]),
              _createVNode(DayBlock, {
                dayData: saturday.value,
                onSetModalContent: setModalContent,
                title: "Saturday 11. June",
                dayName: "Saturday"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["dayData"]),
              _createVNode(DayBlock, {
                dayData: sunday.value,
                onSetModalContent: setModalContent,
                title: "Sunday 12. June",
                dayName: "Sunday"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["dayData"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ModalSchedule, {
      modelValue: modalContent.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalContent).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})